const editorOptions = {
	behavioursEnabled: true,
	cursorStyle: 'smooth',
	fixedWidthGutter: true,
	fontFamily: '"SF Mono", Consolas, Menlo, Courier, monospace',
	fontSize: '15px',
	indentedSoftWrap: true,
	newLineMode: 'unix',
	printMargin: false,
	scrollPastEnd: 0.5,
	tabSize: 2,
	theme: 'ace/theme/dracula',
	useSoftTabs: true,
	wrap: 'printMargin',
	wrapBehavioursEnabled: true,
}

export { editorOptions as options }
